import { render, staticRenderFns } from "./m-block-switch-supplies-setting.vue?vue&type=template&id=654ae0d8&scoped=true&lang=pug&"
import script from "./m-block-switch-supplies-setting.vue?vue&type=script&lang=js&"
export * from "./m-block-switch-supplies-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ae0d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
